import script from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"

import "./SearchUsers.vue?vue&type=style&index=0&id=29e2e93d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e2e93d"]])

export default __exports__